import { Timestamp } from '@firebase/firestore-types';

export namespace Organizations {
  export enum IndexField {
    CREATED_AT = 'createdAt',
    DOMAIN = 'domain'
  }

  export enum FirebaseAuthByEmailProviderId {
    MICROSOFT = 'microsoft.com',
    GOOGLE = 'google.com',
    FIREBASE = 'firebase'
  }

  export class Settings {
    youtubeChannelId: string;
    tvUrl: string;
    profileTypes: Array<string>;
  }
}

export class Organization {
  id?: string;
  authByEmailProviderId: Organizations.FirebaseAuthByEmailProviderId;
  name: string;
  domain: string;
  settings: Organizations.Settings;
  pictureUrl: string;
  primaryColor: string;
  categories: string[];
  groups: string[];
  createdAt: Timestamp;
  modifiedAt: Timestamp;
}
